<section>

  <div class="flex justify-between items-end">
    <div>
      <h1>Departments</h1>
    </div>
    <div *ngIf="iscreateaccess">
      <button (click)="openDepartmentModal()" class="btn btn-sm flex items-center btn-primary"><i
          class="ri-add-line"></i> {{departmentForm.value.id ? 'Update' : 'Create'}} Departments</button>
    </div>
  </div>

  <div class="mt-5">
    <div class="bg-white border border-gray-200 rounded-lg flex items-center w-2/5 px-3"><i
        class="ri-search-2-line"></i> <input type="text" [(ngModel)]="searchStr" (ngModelChange)="search()"
        placeholder="Search" class="outline-none ml-2 w-full py-2">
    </div>
  </div>

  <div class="p-5 bg-white rounded-lg mt-5 border" *ngIf="isviewaccess">

    <div class="overflow-x-auto" >
      <table class="table table-auto w-full" >
        <!-- head -->
        <thead>
          <tr>
            <!-- <th class="w-14"><input type="checkbox" class="checkbox checkbox-sm" /></th> -->
            <th class="w-auto">Department Name</th>
            <th>HOD</th>
            <th class="w-28">No. of Classes</th>
            <th class="w-56">Action</th>
          </tr>
        </thead>
        <tbody>
            @if (isFetching) {
    <!-- Loader Row -->
    <tr>
      <td colspan="5" class="py-10">
        <div class="flex justify-center">
          <app-loader></app-loader>
        </div>
      </td>
    </tr>
  } @else {
    @if (Array.isArray(departmentList) && departmentList.length) {
      @for (i of departmentList; track $index) {
        <tr>
          <!-- <th><input type="checkbox" class="checkbox checkbox-sm" /></th> -->
          <td class="break-words">{{ i?.department_name }}</td>
          <td>{{ i?.hod_name }}</td>
          <td>{{ i?.class_count != null ? i.class_count : '-' }}</td>
          <td>
            <div class="flex gap-2 justify-center">
              <!-- <button *ngIf="isviewaccess" class="btn btn-sm flex items-center btn-light" (click)="openPerformance(i.id)"><i class="ri-eye-line"></i></button> -->
              <button *ngIf="isupdateaccess" (click)="openDepartmentModal(i)" class="btn btn-sm flex items-center btn-light"><i class="ri-pencil-line"></i></button>
              <button *ngIf="isdeleteaccess" (click)="deleteDepartment(i.id)" class="btn btn-sm flex items-center btn-light"><i class="ri-delete-bin-line"></i></button>
              <a *ngIf="isperformanceaccess" [routerLink]="['/performance','department', i.id]" class="btn btn-sm flex items-center btn-light"><i class="ri-bar-chart-line"></i></a>
              <button *ngIf="ischatstudentaccess" class="btn btn-sm flex items-center btn-light" (click)="openChat(i.id)"><i class="ri-message-3-line"></i></button>
            </div>
          </td>
        </tr>
      }
    } @else {
      <!-- No Data Row -->
      <tr>
        <td colspan="5" class="py-10">
          <div class="flex justify-center">
            <p class="font-mono italic">No data to display.</p>
          </div>
        </td>
      </tr>
    }
  }



        </tbody>
      </table>
    </div>



  </div>

  <div class="mt-5 flex justify-center">
    <app-pagination [data]="paginationData" (pageChange)="pageChange($event)"></app-pagination>
  </div>


</section>

<!-- create/edit department modal -->
<dialog id="addDepartMent" class="modal" #modalDepartment appPreventEscClose>
  <div class="modal-box max-w-sm">

    <div class="flex justify-between items-center font-semibold">
      <p>{{departmentForm.value.id ? 'Update' : 'Create'}} Departments</p>
      <button (click)="closeDepartmentModal()"
        class="btn btn-circle btn-sm btn-light flex justify-center items-center"><i class="ri-close-line"></i></button>
    </div>
    <hr class="mt-4 mb-1">

    <form [formGroup]="departmentForm" (ngSubmit)="onSubmitDepartmentForm()">

      <label class="form-control w-full ">
        <div class="label">
          <span class="label-text">Department Name</span>
        </div>
        <input
          [ngClass]="{'error': departmentForm.get('department_name')?.invalid && departmentForm.get('department_name')?.touched}"
          formControlName="department_name" type="text" placeholder="Type here" class="input input-bordered w-full " />
        @if (departmentForm.get('department_name')?.touched && departmentForm.get('department_name')?.invalid) {
        @if (departmentForm.get('department_name')?.hasError('required')) {
        <span class="block mt-1 text-xs text-red-500">Department name is required.</span>
        } @else if (departmentForm.get('department_name')?.hasError('trim')) {
        <span class="block mt-1 text-xs text-red-500">Department name must not have leading or trailing spaces.</span>
        } @else if (departmentForm.get('department_name')?.hasError('minlength')) {
        <span class="block mt-1 text-xs text-red-500">Department name must be at least 3 characters.</span>
        } @else if (departmentForm.get('department_name')?.hasError('maxlength')) {
        <span class="block mt-1 text-xs text-red-500">Department name must be 100 characters or fewer.</span>
        } @else if (departmentForm.get('department_name')?.hasError('pattern')) {
        <span class="block mt-1 text-xs text-red-500">Only letters (A–Z), numbers (0–9), space, &, and - are allowed.</span>
        }
        }


      </label>

      <label class="form-control w-full mt-3">
        <div class="label">
          <span class="label-text">HOD</span>
        </div>
        <select [ngClass]="{'error': departmentForm.get('user_id')?.invalid && departmentForm.get('user_id')?.touched}"
          class="select select-bordered w-full " formControlName="user_id">
          <option disabled selected>Select Hod</option>
          @for (i of hodList; track $index) {
          <option [value]="i.id">{{i.name}}</option>
          }
        </select>
        <div class="mt-1 flex items-center justify-between gap-2">
         

          
        </div>

        @if (departmentForm.get('user_id')?.invalid && departmentForm.get('user_id')?.touched) {
        <span class="text-xs text-red-500">HOD is required</span>
        }
      </label>


      <div class="mt-3 flex justify-end gap-3">
        <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
          @if (isreqSending) {
          <i class="ri-loader-2-line animate-spin"></i>
          }@else {
          <span>Save</span>
          }
        </button>
        <button type="button" (click)="closeDepartmentModal()" class="btn btn-sm btn-light">Cancel</button>
      </div>
    </form>

  </div>
</dialog>
<!-- create/edit department modal -->
